// extracted by mini-css-extract-plugin
module.exports = {"InventoryTypeBadge":"InventoryTypeBadge_InventoryTypeBadge__1W-b7","collapsed":"InventoryTypeBadge_collapsed__16hxD"};